import styled from "styled-components";
import { FlexRow } from "app/components/React/Table/cells/DomainListWithTooltip/styled";
import { colorsPalettes } from "@similarweb/styles";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledIntentTopicTableContainer = styled(FlexColumn)`
    width: 100%;
    height: 100%;
    flex-grow: 1;
`;

export const StyledIntentTopicSearchBlock = styled(FlexRow)`
    position: relative;
    border-top: 1px solid ${colorsPalettes.carbon[100]};
    width: 100%;
`;

export const StyledIntentCategoryDDBlock = styled.div`
    position: absolute;
    right: 24px;
    top: 12px;
`;

export const SearchContainerWrapper = styled.div`
    display: flex;
    width: 100%;
`;

export const SearchContainer = styled.div`
    width: calc(100% - 200px);
    padding-bottom: 10px;
    padding-top: 10px;
    .SearchInput-container .SearchInput {
        height: 30px;
        background-color: ${colorsPalettes.carbon[0]};
        border: none;
        width: 100%;
        box-sizing: border-box;
        padding: 9px 2px 5px 50px;
        box-shadow: none;
        margin-bottom: 0px;
        &:focus {
            box-shadow: none !important;
            border: none;
        }
    }
`;

export const StyledTableWrapper = styled(FlexColumn)`
    display: flex;
    height: calc(100vh - 300px);
    overflow-y: auto;
    overflow-x: hidden;
    flex-grow: 1;
`;

export const StyledSWReactTableContainer = styled.div`
    flex-grow: 1;

    & > div {
        height: 100%;
        box-sizing: border-box;
    }
`;

export const TablePagerContainer = styled.div`
    padding: 10px 15px;
    display: flex;
    flex-direction: row-reverse;
`;
